<template>
    <b-card no-body>
        <div slot="header">{{ $t('label.roles') }}</div>

        <b-form-group style="padding: 10px" v-if="editEnabled">
            <label style="font-weight: bold">
                {{ $t('label.primaryRole') }}
            </label>
            <multiselect
                v-model="user.role"
                @input="roleChanged"
                label="name"
                track-by="id"
                :options="roleList"
                :allowEmpty="false"
            />
        </b-form-group>

        <label style="font-weight: bold; margin-left: 10px; margin-top: 10px">
            {{ $t('label.managerRoles') }}
        </label>
        <b-list-group flush>
            <b-list-group-item
                v-for="m in managingUnitsList"
                :key="m.id"
                class="animated fadeIn hoverable-list-group-item"
            >
                {{ m.unit.name }}
                <a-popconfirm
                    :title="$t('confirm.delete')"
                    @confirm="deleteMananagingUnit(m)"
                    v-if="editEnabled"
                >
                    <a-button
                        type="danger"
                        class="pull-right"
                        size="small"
                        shape="circle"
                        :title="$t('label.confirm')"
                    >
                        <i class="fa fa-trash" />
                    </a-button>
                </a-popconfirm>
            </b-list-group-item>

            <b-list-group-item v-if="editEnabled">
                <!-- Add managing unit button -->
                <b-btn
                    v-if="!showAddDialogue"
                    block
                    variant="ghost-primary"
                    @click="showAddDialogue = !showAddDialogue"
                >
                    <i class="fa fa-plus" />
                    {{ $t('text.addManagingUnit') }}
                </b-btn>
                <!-- Cancel managing unit button -->
                <b-btn
                    v-if="showAddDialogue"
                    block
                    variant="ghost-default"
                    @click="showAddDialogue = !showAddDialogue"
                >
                    <i class="fa fa-minus" />
                    {{ $t('label.cancel') }}
                </b-btn>
            </b-list-group-item>

            <b-list-group-item v-if="showAddDialogue && editEnabled">
                <UnitDropdown
                    :org-id="user.company_id"
                    @select="onSelect"
                    :disabled="!editEnabled"
                />
            </b-list-group-item>
        </b-list-group>

        <!-- <AddManagerAccess
                :user_id="this.user.id"
                :company_id="this.user.company_id"
                :allowedToEdit="canEdit"
                :currentDepartmentID="this.user.department_id"
        />-->
    </b-card>
</template>
<script>
import { mapGetters } from 'vuex'
import UnitDropdown from '@/components/UnitDropdown'
import orderBy from 'lodash/orderBy'

export default {
    components: {
        UnitDropdown,
    },

    props: {
        user: {
            required: true,
        },
        canEdit: {
            type: Boolean,
            default: false,
        },
        editEnabled: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            showAddDialogue: false,
            managingUnits: this.$resource('managerUnitAccesses'),
        }
    },

    created() {
        this.loadManagingUnits()
    },

    methods: {
        loadManagingUnits() {
            let managingUnits = this.managingUnits

            managingUnits.setIncludes('unit')
            managingUnits.setFilter({
                user_id: this.user.id,
            })
            managingUnits.setPerPage(100)
            managingUnits.on('fetch', () => {
                // console.log('onFetch', res)
                // if (res.response.data.total < 1) {
                //     // console.log('No managing units', res)
                // }
            })
            managingUnits.fetch()
        },

        onSelect(unit) {
            this.addManagingUnit(unit)
            this.showAddDialogue = false
        },

        addManagingUnit(unit) {
            let model = this.managingUnits.createModel({
                user_id: this.user.id,
                unit_id: unit.id,
            })

            // console.log('Adding managing unit', model)

            model.save()
            model.on('save', res => {
                // console.log('Save successful!')
                this.managingUnits.add(res.target)
            })
        },

        deleteMananagingUnit(unit) {
            // console.log('Deleting managingunit', unit)

            unit.on('delete', () => {
                alert(this.$t('deleted'))
            })
            unit.delete()
        },

        roleChanged(role) {
            // console.log('RoleChanged', role)
            this.user.role_id = role.id
            this.user.role = role
            this.$emit('change', {
                role_id: role.id,
                role,
            })
        },
    },
    computed: {
        ...mapGetters({
            roles: 'roles/roles',
            authUser: 'auth/user',
            isManager: 'auth/isManager',
        }),

        managingUnitsList() {
            return orderBy(this.managingUnits.models, 'unit.name')
        },

        roleList() {
            return this.roles.filter(r => r.rank >= this.authUser.role.rank)
        },
    },
}
</script>
<style scoped>
label {
    font-weight: bold;
}
.hoverable-list-group-item:hover {
    background: #eee;
}
</style>
